export const en = {
    cases: 'Cases',
    help: 'Help',
    'online-courses': 'Online training',
    site: 'Site',
    study: 'Courses'
};
